(function(){
  function getList(){
    try { return JSON.parse(localStorage.getItem('wishlist') || '[]'); } catch(e){ return []; }
  }
  function setList(list){
    try { localStorage.setItem('wishlist', JSON.stringify(list)); } catch(e){}
  }
  function refreshButtons(){
    var list = getList();
    document.querySelectorAll('.wishlist-btn').forEach(function(btn){
      var handle = btn.dataset.wishlistHandle;
      if (list.indexOf(handle) > -1){
        btn.classList.add('active');
        btn.innerHTML = '&#9829;';
      } else {
        btn.classList.remove('active');
        btn.innerHTML = '&#9825;';
      }
    });
  }
  document.addEventListener('click', function(e){
    var btn = e.target.closest('.wishlist-btn');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    var handle = btn.dataset.wishlistHandle;
    var list = getList();
    var idx = list.indexOf(handle);
    if (idx > -1){ list.splice(idx,1); } else { list.push(handle); }
    setList(list);
    refreshButtons();
  });
  if (document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', refreshButtons);
  } else {
    refreshButtons();
  }
})();
